module.exports = __webpack_public_path__ + "static/pot3-b2050a8288220995e04d9be4bfce88f9.svg";